import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';

export interface PendingApprovalCounts {
  total: number;
  byEntityName: Record<string, number>;
}

@Injectable({ providedIn: 'root' })
export class PendingApprovalCountService {
  private readonly pendingCountsSubject = new BehaviorSubject<PendingApprovalCounts | null>(null);
  readonly pendingCounts$ = this.pendingCountsSubject.asObservable();

  constructor(private readonly httpClient: HttpClient) {}

  refreshPendingCounts(): Observable<PendingApprovalCounts> {
    return this.httpClient.get<PendingApprovalCounts>('/api/referential-approval-requests/pending-count').pipe(
      tap(counts => this.pendingCountsSubject.next(counts)),
    );
  }

  clearPendingCounts(): void {
    this.pendingCountsSubject.next(null);
  }
}